<template>
  <div class="tags-box">
    <el-dialog
      :title="'图集详情'"
      :visible.sync="dialogVisible"
      :width="width"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <div class="picturePopup" :style="{ overflow: over }">
        <div v-for="(item, i) in pictureList" :key="i" class="pictureInside">
          <decrypt-img
            style="width: 180px; height: 180px"
            :src="imgUrl + item.src"
            :fit="fit"
          ></decrypt-img>
          <!-- <base-upload
            :cover="item.src"
            :action="action"
            @successCallback="item.successCallback"
            :wSize="360"
            :hSize="480"
            :width="'180px'"
            :height="'180px'"
            :hide="true"
          ></base-upload> -->
          <!-- <el-button type="danger" icon="el-icon-delete" circle size="small" class="deleteButton" @click="deletePicture(i)"></el-button> -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import baseConfig from "@/utils/serverUrlConfig";
export default {
  data() {
    return {
      id: "",
      tags: [],
      flag: false,
      dialogVisible: false,
      // 封面上传地址
      action: baseConfig.baseServerUrl + "/vid/uploadStatic",
      imgUrl: baseConfig.imgUrl,
      pictureList: [],
      picturePopupLength: ["240px", "430px", "620px"],
    };
  },
  computed: {
    width() {
      if (this.pictureList.length < 4 && this.pictureList.length > 0) {
        return this.picturePopupLength[this.pictureList.length - 1];
      } else if (this.pictureList.length < 10) {
        return "620px";
      } else {
        return "640px";
      }
    },
    over() {
      return this.pictureList.length < 10 ? "hidden" : "auto";
    },
  },
  methods: {
    // 封面图上传成功回调
    successCallback(res) {
      this.params.cover = res.data.coverImg;
    },
    // 删除某张图片
    deletePicture(i) {
      if (this.pictureList.length === 1) {
        this.$message.error("请至少保留一张！");
        return;
      }
      this.pictureList.splice(i, 1);
    },
    // 新增图片
    addPicture() {
      let obj = {
        src: "",
        successCallback(res) {
          obj.src = res.data.coverImg;
        },
      };
      this.pictureList.push(obj);
    },
    // 打开弹窗并初始化tags数据
    open(pictureArr) {
      this.dialogVisible = true;
      let arr = [];
      for (var i = 0; i < pictureArr.length; i++) {
        let obj = {
          src: pictureArr[i],
          successCallback(res) {
            obj.src = res.data.coverImg;
          },
        };
        arr.push(obj);
      }
      this.pictureList = arr;
    },
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.pictureList = [];
    },
  },
};
</script>
<style scoped lang="scss">
.tags-box {
  .el-dialog {
    padding: 0 !important;
    margin: 0 !important;
  }
  .input-box {
    margin-top: 15px;
    text-align: left;
  }
  .el-input {
    width: 200px;
    margin-right: 10px;
  }
  .picturePopup {
    border: solid 5px white;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    max-height: 580px;
    .pictureInside {
      margin: 5px;
      position: relative;
      .deleteButton {
        position: absolute;
        opacity: 0.5;
        top: 0;
        right: 0;
      }
    }
  }
}
</style>
